import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {StyledExpensesPage} from './StyledExpensesPage';
import DashboardPageTransition from '../../components/animations/DashboardPageTransition';
import ExpensesPanel from '../../components/pages/ExpensesPage/ExpensesPanel';
import InvoiceForward from '../../components/pages/InvoicesPage/InvoiceForward/InvoiceForward';
import BalancePageHeader from '../../components/pages/TransactionsPage/BalancePageHeader/BalancePageHeader';
import PageDocumentDetails from '../../components/PageDocumentDetails/PageDocumentDetails';
import {useIsEmployeeLoaded} from '../../hooks';

const ExpensesPage = () => {
  const [t] = useTranslation('main');

  const isAdmin = useSelector(state => state.user.isAdmin);

  const title = t('pageTitles.expensesList');

  const isEmployeeLoaded = useIsEmployeeLoaded();

  return (
    <StyledExpensesPage>
      <PageDocumentDetails title={title} />
      <BalancePageHeader breadcrumbs={[{ title }]} />
      {(isEmployeeLoaded && !isAdmin) && <InvoiceForward />}
      <DashboardPageTransition>
        <ExpensesPanel />
      </DashboardPageTransition>
    </StyledExpensesPage>
  );
}

export default ExpensesPage;
